
/**
 * @description: 订单状态
 */
export const OrderStatusCode = {
  TO_BE_SUBMITTED: {
    val: '0',
  }, // 待提交，货主端文案用待提交
  // 后端说货主不会有1的状态
  TO_BE_DISPATCH: {
    val: '2',
  }, // 待派车
  TO_BE_START: {
    val: '3'
  }, // 待提货
  TO_BE_SIGN: {
    val: '4',
  }, // 运输中-代签收
  PART_SIGN: {
    val: '5',
  }, // 运输中-部分签收
  IN_TRANSIT: {
    val: '4,5',
  }, // 运输中
  BALANCE_CHECK: {
    val: '6',
  }, // 已签收
  CANCEL: {
    val: '9',
    defalutNotShow: true,
  }, // 已取消
  ABNORMAL: {
    val: '100',
  }, // 异常
}

export const OrderStatus = {
  [OrderStatusCode.TO_BE_SUBMITTED.val]: '待接单', // 待提交，货主端文案也用待提交
  [OrderStatusCode.TO_BE_DISPATCH.val]: '待派车', // 待派车
  [OrderStatusCode.TO_BE_START.val]: '待提货', // 待提货
  [OrderStatusCode.TO_BE_SIGN.val]: '运输中', // 运输中-代签收
  [OrderStatusCode.PART_SIGN.val]: '运输中', // 运输中-部分签收
  [OrderStatusCode.IN_TRANSIT.val]: '运输中', // 运输中
  [OrderStatusCode.BALANCE_CHECK.val]: '已签收', // 已签收
  [OrderStatusCode.CANCEL.val]: '已取消', // 已取消
  [OrderStatusCode.ABNORMAL.val]: '异常', // 异常
}

export const D_STATUS = {
  TO_BE_SUBMITTED: 0, // 待提交，货主端文案用待提交
  TO_BE_DISPATCH: 2, // 待派车
  TO_BE_START: 3, // 待提货
  TO_BE_SIGN: 4, // 运输中-代签收
  PART_SIGN: 5, // 运输中-部分签收
  BALANCE_CHECK: 6, // 已签收
  CANCEL: 9, // 已取消
  ABNORMAL: 100, // 异常
}
// D订单状态
export const DSTATUSCODE = {
  // TO_BE_SUBMITTED: 0, // 待提交，货主端文案用待提交
  // TO_BE_DISPATCH: 2, // 待派车
  // TO_BE_START: 3, // 待提货
  // TO_BE_SIGN: 4, // 运输中-代签收
  // PART_SIGN: 5, // 运输中-部分签收
  // BALANCE_CHECK: 6, // 已签收
  // CANCEL: 9, // 已取消
  // ABNORMAL: 100, // 异常
  TO_BE_SUBMITTED: 'TO_BE_SUBMITTED', // 待提交，货主端文案用待提交
  TO_BE_DISPATCH: 'TO_BE_DISPATCH', // 待派车
  TO_BE_START: 'TO_BE_START', // 待提货
  TO_BE_SIGN: 'TO_BE_SIGN', // 运输中-代签收
  PART_SIGN: 'PART_SIGN', // 运输中-部分签收
  BALANCE_CHECK: 'BALANCE_CHECKED', // 已签收
  CANCEL: 'CANCEL', // 已取消
  ABNORMAL: 'EXP_CAL_STATUS', // 异常
  TOBEDEAL: 'TO_BE_DEAL', // 待接单
  CANCELED: 'CANCELED', // 已取消
};

export const OrderStatusList = {
  'TO_BE_SUBMITTED': '待接单', // 待提交，货主端文案用待提交
  'TO_BE_DISPATCH': '待派车', // 待派车
  'TO_BE_START': '待提货', // 待提货
  'TO_BE_SIGN': '运输中', // 运输中-代签收
  'PART_SIGN': '运输中', // 运输中-部分签收
  'BALANCE_CHECKED': '已签收', // 已签收
  'CANCELED': '已取消', // 已取消
  'EXP_CAL_STATUS': '计费异常', // 异常
  'TO_BE_DEAL': '待接单', // 待接单
  FOR_CREDIT: '授信余额评估中',
  FAIL_CREDIT: '授信余额不足',
}

export const UnifyOrderStatus = {
  DRAFT: '待接单',
  SUBMITTED: '待接单',
  DEAL: '待派车',
  BIDDING: '议价中',
  STARTED: '运输中',
  SIGNED: '已签收',
  CANCELED: '已取消',
  EXP_CAL_STATUS: '计费异常',
  PART_SIGNED: '部分签收',
  DISPATCHED: '已派车',
  CARRIER_BIDDING: '询价中',
  FOR_CREDIT: '授信余额评估中',
  FAIL_CREDIT: '授信余额不足',
}
export const UnifyOrderStatusKey = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  DEAL: 'DEAL',
  BIDDING: 'BIDDING',
  STARTED: 'STARTED',
  SIGNED: 'SIGNED',
  CANCELED: 'CANCELED',
  EXP_CAL_STATUS: 'EXP_CAL_STATUS',
  PART_SIGNED: 'PART_SIGNED',
  DISPATCHED: 'DISPATCHED',
  CARRIER_BIDDING: 'CARRIER_BIDDING',
  FAIL_CREDIT: 'FAIL_CREDIT',
  FOR_CREDIT: 'FOR_CREDIT',
}

// 订单进度tab
export const OrderProgressTab = {
  ALL: 'ALL',
  DOING: 'DOING',
  FINISH: 'FINISH',
  CANCEL: 'CANCEL'
}
export const OrderProgressTabMap = [
  { key: OrderProgressTab.ALL, title: '全部' },
  { key: OrderProgressTab.DOING, title: '进行中' },
  { key: OrderProgressTab.FINISH, title: '已完成' },
  { key: OrderProgressTab.CANCEL, title: '已取消' }
];
// 订单进度状态
export const OrderProgressStatus = {
  [OrderProgressTab.ALL]: [
    OrderStatusCode.TO_BE_SUBMITTED, // 待提交
    OrderStatusCode.TO_BE_DISPATCH, // 待派车
    OrderStatusCode.TO_BE_START, // 待提货
    // OrderStatusCode.TO_BE_SIGN, // 运输中-代签收
    // OrderStatusCode.PART_SIGN, // 运输中-部分签收
    OrderStatusCode.IN_TRANSIT,
    OrderStatusCode.BALANCE_CHECK, // 已签收
    OrderStatusCode.CANCEL,
    OrderStatusCode.ABNORMAL,
  ],
  [OrderProgressTab.DOING]: [
    OrderStatusCode.TO_BE_SUBMITTED, // 待提交
    OrderStatusCode.TO_BE_DISPATCH, // 待派车
    OrderStatusCode.TO_BE_START, // 待提货
    // OrderStatusCode.TO_BE_SIGN, // 运输中-代签收
    // OrderStatusCode.PART_SIGN, // 运输中-部分签收
    OrderStatusCode.IN_TRANSIT,
    OrderStatusCode.ABNORMAL, // 异常
  ],
  [OrderProgressTab.FINISH]: [
    OrderStatusCode.BALANCE_CHECK, // 已签收
  ],
  [OrderProgressTab.CANCEL]: [
    OrderStatusCode.CANCEL,
  ]
};

// 用车类型
export const orderTypeMap = {
  0: '整车',
  1: '零担',
  TRUCKLOAD: '整车',
  BREAK_BULK: '零担',
}

// 订单来源
export const OdrChannelMap = {
  1: '承运商下单',
  5: '导入订单',
  6: '六和订单',
  7: '乳业订单',
  8: '邮件下单',
  10: 'WMS下单',
  11: '果盘APP下单',
  12: '主订单衍生',
  13: '小程序订单',
  14: '商流订单',
  15: '页面下单',
  16: '导入下单',
  17: '货主openapi下单',
  19: '货主小程序下单',
  20: '货主APP下单'
}

// 用车需求
export const TransportType = {
  TRUCKLOAD: 'TRUCKLOAD', // 整车 0
  BREAK_BULK: 'BREAK_BULK', // 零担 1
}
/**
 * @description: 运单配载状态
 */
export const WaybillStatusText = [
  { label: '转派', value: -2 },
  { label: '取消接单', value: -1 },
  { label: '未接单', value: 0 },
  { label: '待派车', value: 1 },
  { label: '已派车', value: 2 },
  { label: '运输中', value: 3 },
  { label: '已签收', value: 4 },
  { label: '待审核', value: 5 },
  { label: '完成', value: 6 },
  { label: '中转', value: 7 },
  { label: '中转撤销', value: 8 },
  { label: '提货', value: 9 },
  { label: '拆分', value: 10 },
  { label: '运输中', value: 11 },
  { label: '已取消', value: 12 }
]




/**
 * @description: 车辆类型、司机类型
 */
export const DriverTypeText = ['自有', '外请', '个体']


// 站点类型
export const StationTypes = {
  SHIPPING: 'SHIPPING', // 出发点
  RECEIVING: 'RECEIVING', // 送货点
  SHIPPING_RECEIVING: 'SHIPPING_RECEIVING', // 出发点+送货点
};

// 状态
export const StatusMap = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED'
}

// 站点性质
export const BizType = {
  TRANSPORT: 'TRANSPORT',// 运输
  TRANSPORT_WAREHOUSE: 'TRANSPORT_WAREHOUSE',// 仓配
}

// 订单详情页 tab 类型
export const DetailTabs = {
  BASEINFO: 'base',
  CARINFO: 'car'
}

export const scrollPosition = {
  top: 'screenTop',
  id: 'popContainer',
  TAB: 'TAB',
  CURRENT: 'CURRENT',
}

export const minGroupSize = 2;

export const TRANSPORT = '运输中'
export const ORDERSTATUS = {
  TRANSPORT: '运输中',
  SUBMIT: '提交订单',
  ORDERSPLIT: '订单拆分'
}

export const NEGOTIABLE = 'NEGOTIABLE'; // 议价

// 议价中报价状态
export const biddingList = {
  BIDDING: 'BIDDING', // ("报价中")
  NORMAL_BID: 'NORMAL_BID', // ("正常报价"),
  NO_BID: 'NO_BID', // ("无人报价"),
  DEAL: 'DEAL', // ("已达成报价"),
  DISABLED: 'DISABLED', // ("无效报价, 重新出价"),
}

export const tabListType = {
  PURE_TRANSPORT:'PURE_TRANSPORT', // 纯运输
  CP: 'CP',
  WAREHOUSE: 'warehouse',
  DELIVER_TRANSPORT:'DELIVER_TRANSPORT', // 仓配一体
  TRANSPORT: 'transport'
}

export const TabTypeIndex = {
  warehouse: 'WAREHOUSE_ONLY',
  DELIVER_TRANSPORT: 'WAREHOUSE_TRANSPORT'
}
// 计费方式
export const chargeOption = [
  {
    value:1,
    label:'合同计费',
  },
  {
    value:2,
    label:'一口价',
  }
]
